import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
const db = firebaseApp.database()

const currentNoticesRef = (currentUserId) => { return db.ref('notices/' + currentUserId) }
export const noticesModule = {
  namespaced: true,
  state: {
    currentNotices: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    [getterConstants.GET_CURRENT_NOTICES]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_NOTICES', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('currentNotices', currentNoticesRef(currentUserId), { wait: true })
    }),
    [getterConstants.SET_LAST_NOTICE]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      // console.log('currentUserId', currentUserId)
      if (currentUserId) {
        const setLastNoticeRef = db.ref('users/' + currentUserId + '/lastNotice')
        setLastNoticeRef.set(value)
        // console.log('set lastNotice::', value)
      } else {
        // console.log('not set lastNotice::')
      }
    })
  },
  getters: {
    getCurrentNotices: state => state.currentNotices,
    getLatestNoticesByUserId: (state, getters, rootState) => {
      let latestNotices = []
      // if (rootState.currentUser && state.currentNotices) {
      //   const currentUser = rootState.currentUser
      //   const currentNotices = state.currentNotices
      const currentUser = rootState.currentUser || {}
      const currentNotices = state.currentNotices
      if (currentUser['.key'] && currentNotices) {
        delete currentNotices['.key']
        delete currentNotices['.value']
        // console.log('getLatestNoticesByUserId:', currentUser['.key'], currentUser, currentNotices)
        for (const key of Object.keys(currentNotices).sort().reverse()) {
          // console.log('getLatestNoticesByUserId:', currentNotices[key], currentNotices[key].createdAt / 1000, currentUser.lastNotice)
          if (currentNotices[key] && currentNotices[key].createdAt / 1000 > (currentUser.lastNotice || 0)) {
            latestNotices.push({ key: key, notice: currentNotices[key] })
          } else {
            break
          }
        }
      }
      // console.log('getLatestNoticesByUserId:latestNotices', latestNotices)
      return latestNotices
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/notices.js